import { useRef, useState } from 'react';
import { useHeaderHeight } from '@hooks/use-header-height';
import { useShell } from '@/context/shell-context';
import { useLocation } from 'react-router';
import type { ReactNode } from 'react';
import type { TLocalize } from '@hooks/use-localize';
import BackToDashboard from '@components/chrome/back-to-dashboard';
import DonorMentorModal from '@components/donor-mentor-modal';
import LanguageDropdown from '@components/language-dropdown';
import Welcome from '@components/chrome/welcome';
import nkrLogo from '@/assets/nkr-logo.svg';
import FamilyBar from './family-bar';
import Footer from './footer';

interface IProps {
    t: TLocalize;
    showMentorButton: boolean;
    hasMultipleLanguages: boolean;
    dashboardLink: string | null;
    children: ReactNode;
}

const NkrChrome = ({ t, showMentorButton, hasMultipleLanguages, dashboardLink, children }: IProps) => {
    const shell = useShell();
    const [mentorModalOpen, setMentorModalOpen] = useState(false);
    const headerRef = useRef<HTMLElement>(null);
    const location = useLocation();

    useHeaderHeight(headerRef, true);

    const isLabOrdersPage = location.pathname.indexOf('lab-orders') >= 0;

    return (
        <div className="intake-form">
            <a className="sr-only" href="#content">
                Skip navigation
            </a>

            <header ref={headerRef}>
                <div className="row">
                    <div className="col-xs-12 col-sm-4">
                        <a href="https://www.kidneyregistry.com">
                            <img src={nkrLogo} alt="National Kidney Registry" />
                        </a>
                    </div>
                    <div className="col-xs-12 col-sm-8 pull-right flex-container">
                        <div>
                            <Welcome t={t} />
                        </div>
                        <div>
                            <BackToDashboard link={dashboardLink} t={t} />
                        </div>
                        {showMentorButton && !isLabOrdersPage && (
                            <div>
                                <a
                                    href="#"
                                    className="btn btn-nkr-red request-donor-mentor-button"
                                    style={{ marginRight: 0, marginLeft: 0 }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setMentorModalOpen(true);
                                    }}
                                >
                                    {t('DashLabel_RequestADonorMentor', 'Request a Donor Mentor')}
                                </a>
                            </div>
                        )}
                        <div>
                            <div id="languagediv">
                                {hasMultipleLanguages && <LanguageDropdown />}
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {mentorModalOpen && (
                <DonorMentorModal
                    t={t}
                    registrationId={shell.registrationId}
                    editKey={shell.editKey}
                    connectToDonorStatus={shell.connectToDonorStatus}
                    onClose={() => setMentorModalOpen(false)}
                />
            )}

            {children}

            <FamilyBar />

            <Footer />
        </div>
    );
};

export default NkrChrome;
